import { render, staticRenderFns } from "./formfield2.vue?vue&type=template&id=537abc4c&scoped=true&lang=html"
import script from "./formfield2.vue?vue&type=script&lang=js"
export * from "./formfield2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537abc4c",
  null
  
)

export default component.exports